import type { AdpAnalytics } from '@innovyze/stylovyze';
import { RiskConfig } from '@Types';
import { useEffect, useRef } from 'react';

export const useTrackRiskResultsView = (
	adp: Pick<AdpAnalytics, 'track'> | null,
	resultCount: number,
	riskConfig: RiskConfig,
) => {
	const trackedThisSession = useRef(false);

	useEffect(() => {
		if (!adp || resultCount <= 0 || trackedThisSession.current) {
			return;
		}

		try {
			adp.track('USER_VIEW', {
				id: 'risk-results-view',
				name: 'User accessed risk results',
				type: 'page-view',
				attributes: {
					riskname: riskConfig.riskSetting.name,
					riskid: riskConfig.riskSetting.configId,
					assettype: riskConfig.riskSetting.assetType,
					resultcount: String(resultCount),
				},
			});

			trackedThisSession.current = true;
		} catch (error) {
			console.warn('Failed to track risk results view', error);
		}
	}, [adp, riskConfig, resultCount]);
};
